import { Paragraph, SectionType, PageOrientation } from "docx";
import { firstHeadlineTable } from "./fistHeadlineTable";
import { averageLines } from "./others";
import { secondTable } from "./secondTable";
import { tableSummary } from "./tableSummary";
import {
  firstThreeLines,
  secondThreeLines,
  tableField,
  tablineDate,
} from "./tablines1";

export const sections = (
  user,
  klausur,
  schueler,
  companies,
  valueObj,
  average,
 ) => {

  return [
    {
      properties: {
        page: {
          type: SectionType.CONTINUOUS,
          size: {
            orientation: PageOrientation.PORTRAIT,
          },
          margin: {
            top: 600,
            right: 600,
            bottom: 600,
            left: 600,
          },
        },
      },
      children: [
        firstHeadlineTable(),
        new Paragraph(""),
        secondTable(user, klausur, schueler, companies),
        new Paragraph(""),
        ...firstThreeLines(),
        tableSummary(valueObj),
        ...averageLines(average),
        new Paragraph(""),
        ...secondThreeLines(),
        new Paragraph(""),
        new Paragraph(""),
        tablineDate(user, klausur, companies),
        new Paragraph(""),
        tableField(),
      ],
    },
  ];
};
